import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CalsoftAuditComponent } from './audit.component';
import { MatTabsModule } from '@angular/material/tabs';
import { ListModule } from 'src/app/shared/list/list.module';
import { CustomFlexLayoutModule } from 'src/app/shared/flex-layout/custom-flex-layout.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { MatDialogModule } from '@angular/material/dialog';
import { AuditTableComponent } from './audit-table/audit-table.component';


@NgModule({
  declarations: [CalsoftAuditComponent, AuditTableComponent],
  imports: [
    CommonModule,
    MatTabsModule,
    ListModule,
    MatIconModule,
    MatButtonModule,
    CustomFlexLayoutModule,
    MatToolbarModule,
    MatDialogModule,
    PerfectScrollbarModule
  ],
  exports: [CalsoftAuditComponent, AuditTableComponent]
})
export class CalsoftAuditModule { }
